import { FC, useEffect, useState, useMemo, memo, useCallback, useRef, ReactNode, lazy } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Nullable, Project, API, ParticipateCompetitions, Lang, Designer } from '@brg/api';
import { useProfile } from '@brg/auth';
import { FlexBox } from '@brg/ui';
import InfiniteScroll from 'react-infinite-scroll-component';

import { ChannelsGrid, GridWrapperNew, ProjectsGridNew, TeamGrid } from '../../shared/components/grids';
import { ProjectCardItem } from './ProjectsButchController/ProjectCardItem';
import useQueryStateOrigin from "../../shared/hooks/useQueryState";
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'shared/icons/Progress';
import styled, { useTheme } from 'styled-components';
import { AppTester } from "supporting";
import { EmptyCardsLoading } from 'shared/components/CardsLoading/EmptyCards';
import { SkeletonCard, SkeletonCardMap } from 'shared/components/SkeletonCard/SkeletonCard';
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { ProjectsGridActions, ProjectsGridSelector } from "../../shared/reducers/ProjectsGridSlice";
import { fetchProjectsGrid, fetchProjectsGridMore } from "../../shared/actions/projectsGridActions";
import { ComputedTeam, computeTeam } from "../../shared/helpers/types/computed/ComputedTeam";
import { DesignerCompetitionsTab } from "../../shared/pages/designer/components/tabs/designerCompetitionsTab";
import { CombinedEvents } from "../../shared/helpers/projectEvents";
import { DraftsGrid } from "../../shared/pages/designer/components/draftsGrid";
import { DesignerTab } from "../../shared/constants/designerTab";
import { ModerationType } from "../../shared/pages/teams/const/ModerationTypes";
import CompetitionGrid from "../../_competition/pages/AllCompetitionsPage/CompetitionGrid";
import WideCoverSlice, { WideCoverSelector } from 'shared/reducers/WideCoverSlice';
import { EmptyCategory } from 'shared/components/EmptyCategory/EmptyCategory';
import { ShopCard } from 'shared/pages/Shop/ShopCard';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import { DesignerDiscountTab } from 'shared/pages/designer/components/tabs/designerDiscountstab';
import { useParams, useRouteMatch as useRouteMatchOrigin } from "react-router-dom";
import { PeoplePageGrid } from 'shared/pages/context/support/Grid';
import { mapProjectToMapObject } from 'shared/pages/ResearchPage/Research/Frames/FramesSsr/mapProjectToMapObject';
import { isServer } from 'shared/constants/isServer';
import { useParamsSsr, useRouteMatchSsr } from 'shared/hooks/useRouteMatchSsr';
import { ProfileFoldersProps, ProfileFoldersSelector } from 'shared/reducers/ProfileFoldersSlice';
import { Placement } from 'shared/components/tooltips';
import useEffectSkipFirst from 'core/hooks/useEffectSkipFirst';
import { ALL_CHANNELS_TEAM_ID } from 'shared/pages/exploreHseContextsNew/const/misc';
import { getNormalizedOuterTeamPath } from 'core/helpers/getNormalizedOuterTeamPath';
import { isManualTab } from './helpers/isManualTab';
import { EMPTY_CONTENT_TAB } from 'shared/pages/designer/components/NoProjectsContent';
import { BroadCastView } from 'shared/components/BroadCastView/BroadCastView';
import { IShowcaseRatingsFilter } from 'shared/constants/ShowcaseRatings';
import yandexWebmaster from 'shared/webmaster/yandexWebmaster';

const useRouteMatch = isServer ? useRouteMatchSsr : useRouteMatchOrigin
const useQueryState = isServer ? () => [{ teachersOnly: false, showcase: false, folderId: false, tagId: false, campusType: false, productCards }] : useQueryStateOrigin
const PopupInfoNodeGrid = isServer ? FlexBox : lazy(() => import('shared/pages/ResearchPage/Research/Components/Popup/stylesSsr/PopupInfoNodeGrid'))
const PopUpInfoNode = isServer ? FlexBox : lazy(() => import('../../shared/pages/ResearchPage/Research/Components/Popup/PopUpInfoNode'))
const usedUseParams = isServer ? useParamsSsr : useParams
const useParamsProps = isServer ? LinkTo.designer : undefined

export const StyledLoading = styled.div`
  margin-bottom: 40px;
  padding: 10px;
  font-size: 60px;
  line-height: 1;
  color: white;
  text-align: center;
`;

export const ShowMoreWrapper = styled(FlexBox)`
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${p => p.theme.progressbar.borderColor};
  border-radius: 3px;
  padding: 12px 48px;
`;

const OffsetBlock = styled.div<{ display: boolean }>`
  width: 100%;
  margin-top: 64px;
  display: ${p => p?.display ? 'inline-block' : 'none'};
`;

const ScrollWrapper = styled(FlexBox)`
  .infinite-scroll-component {
    overflow: visible !important;
  }
`

type Tabs = {
  [key: string]: string[] | string | null;
}

export interface ProjectsButchControllerProps<T = Project> {
  filter: any;
  onProjectsLoaded?: (projects: T[]) => void;
  selectable?: boolean;
  onSelect?: (projectId: string) => void;
  withoutGoToProject?: boolean;
  withoutRepost?: boolean;
  selectedProjects?: string[];
  isParticipate?: string[];
  modal?: boolean;
  linkPrefix?: string;
  projectsCount?: number;
  isLoading?: Function;
  isSelectRightNeed?: boolean;
  columns?: number;
  isUnload?: boolean;
  preloadedTabs?: Tabs[];
  emptyMsgComponent?: ReactNode;
  currentTab: string;
  currentCategory: string;
  contextName?: string;
  isPageWithoutTabs?: boolean;
  emptyMsgText?: string;
  showCompetitionPoint?: boolean;
  isChannelParticipant?: boolean;
  isTeamProjects?: boolean;
  isDisabled?: boolean;
  canMakeImageForTeam?: TOwnerRights;
  isMainPage?: boolean;
  isProfile?: boolean;
  isPeoplePage?: boolean;
  isCompetitions?: boolean;
  handlers?: CombinedEvents;
  moderationType?: ModerationType;
  loading?: boolean;
  teamId?: string;
  team?: any;
  accountId?: string;
  mobileColumns?: number;
  scrollableTarget?: any;
  isMe?: number;
  scrollStyles?: any;
  showOpa?: boolean;
  channelOwnerId?: string;
  isOpaCard?: boolean;
  isMobileMoreVisible?: boolean;
  placement?: Placement;
  onScroll?: (e: any) => void;
  isExport?: boolean;
}

const ProjectsButchControllerUltimate: FC<ProjectsButchControllerProps> = ({
  filter,
  selectable = false,
  modal = false,
  onSelect = () => undefined,
  withoutGoToProject,
  selectedProjects = [],
  isParticipate = [],
  linkPrefix,
  columns,
  isPageWithoutTabs,
  withoutRepost,
  contextName,
  teamId,
  team,
  accountId,
  currentTab,
  scrollStyles,
  currentCategory,
  showCompetitionPoint,
  canMakeImageForTeam,
  isProfile,
  isPeoplePage,
  isCompetitions,
  isMainPage,
  handlers,
  mobileColumns,
  loading,
  emptyMsgComponent,
  isChannelParticipant,
  emptyMsgText,
  moderationType,
  scrollableTarget,
  isMe,
  showOpa,
  isOpaCard,
  channelOwnerId,
  placement,
  onScroll,
  onProjectsLoaded,
  isExport,
}) => {
  const designer = useProfile();
  const theme = useTheme();
  const isMapPage = useRouteMatch('/map');
  const isFeedPage = useRouteMatch('/feed');
  const isResidentsPage = !!useRouteMatch('/residents');

  const [{ teachersOnly, showcase = false, folderId, tagId, campusType, productCards }] = useQueryState();
  const { id: designerId } = usedUseParams(useParamsProps)

  const dispatch = useDispatch();
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isMedia = AppTester.isMediiia();
  const isMediiiaConcept = AppTester.isMediiiaConcept()
  const isLMSHSE = AppTester.isLMSHSE();
  const isGreenAward = AppTester.isGreenAward();
  const isDafes = AppTester.isGeoDafes();
  const isHH = AppTester.isContext('hsehh');
  const isHseCreative = AppTester.isLMSHSECreative();
  const isLectureMedia = AppTester.isLectureMediiia();
  const isSchool = AppTester.isSchool()
  const isStart = AppTester.isStartHSE();
  const isExam = AppTester.isExamHSE()
  const isAcademy = AppTester.isAcademy();
  const isMap = !!useRouteMatch('/map');
  const isExactPage = !!useRouteMatch('/');
  const isMainPageHseSpace = AppTester.isContext('hsespace') && isExactPage;
  const isHseSpaceDesignerPage = AppTester.isContext('hsespace') && !!useRouteMatch(LinkTo.designer)
  const { t, i18n, i18n: { language } } = useTranslation();
  const [time, setTime] = useState(Date.now());
  const [initialLoaded, setInitialLoaded] = useState(false)
  const initialLoadedRef = useRef(false)
  const tabDataRef = useRef<any>(null)

  const prevUserId = useRef<any>(null);

  const hasWideCover = useSelector(WideCoverSelector)?.project;
  const preloadedTabs = useSelector(ProjectsGridSelector)?.tabs;
  const preloadedTabsContext = useSelector(ProjectsGridSelector)?.context;
  const data = useSelector(ProjectsGridSelector)?.data?.[currentCategory]?.[currentTab];
  const fetchingTabs = useSelector(ProjectsGridSelector)?.tabsLoading?.[currentCategory]?.[currentTab];
  const fetchingMore = useSelector(ProjectsGridSelector)?.fetchingMore;
  const prevTeam = useSelector(ProjectsGridSelector)?.prevTeam;
  const ratingsFilter = useSelector(ProjectsGridSelector)?.ratingsFilter;
  const prevRatingsFilterRef = useRef<IShowcaseRatingsFilter | undefined>(ratingsFilter);
  const currentFolder = useSelector(ProfileFoldersSelector)?.currentFolder;
  const prevProductCardState = useSelector(ProjectsGridSelector)?.prevProductCardFilter;
  //@ts-ignore
  const currentTeam = useSelector((state) => state?.organizations)?.team;

  tabDataRef.current = data;

  const isChannel = useMemo(() => {
    return moderationType && [/*ModerationType.Channel,*/ ModerationType.ChannelGroupOrCourse]?.includes(moderationType)
  } , [moderationType])

  const isOuterOrganizationShowcase = useMemo(
    () => moderationType === ModerationType.Outer || team?.moderationType === ModerationType.Outer,
    [moderationType, team],
  )

  const isSuperPuperGames = useMemo(
    () => ((currentTeam?.contextName === 'superpupergames-mediiia'))
    , [currentTeam]);

  const currentTabContentDisplayLinkParams = useMemo(
    () => preloadedTabs?.main?.find((x: any) => x.path === currentTab)?.entityTypeAdditionalLinkParams,
    [preloadedTabs, currentTab]
  );

  const currentTabConfig = useMemo(
    () => preloadedTabs?.[currentCategory]?.find((x: any) => x.path === currentTab)
      ?? preloadedTabs?.main?.find((x: any) => x.path === currentTab),
    [preloadedTabs, currentCategory, currentTab],
  );

  const broadcastLink = useMemo(
    () => currentTabConfig?.filter?.broadcastLink
      ?? currentTabConfig?.broadcastLink
      ?? filter?.broadcastLink
      ?? '',
    [currentTabConfig, filter?.broadcastLink],
  );

  const hideProjects = useMemo(() => {
    if (currentTab === EMPTY_CONTENT_TAB) {
      return false
    }
    return ([ProfileFoldersProps.create, ProfileFoldersProps.edit]?.includes(currentFolder) || folderId) && isProfile
  }, [folderId, isProfile, currentFolder, currentTab])

  const disableFetchingMore = useMemo(() => {
    if (currentTab === 'competitionCerts') return true;
    return isManualTab(data?.usingFilterOrManual)
  }, [data?.usingFilterOrManual])

  const reloadAllTabs = useCallback(() => {
    setTime(Date.now());
    handlers?.onUpdate?.();
  }, [handlers])

  const { isFinalPage, paging, entityType, isDrafts, hasAnnotation } = data || {};
  const ratingsTabEntityType = currentTabConfig?.entityType || entityType;
  const isRatingsEntityType = ['projects_ratings', 'authors_ratings'].includes(ratingsTabEntityType);

  const hasCachedData = useMemo(() => {
    return !!(data?.data && data.data.length > 0);
  }, [data]);

  useEffect(() => {
    if (isProfile && prevUserId.current && prevUserId.current !== designerId) {
      dispatch(ProjectsGridActions.resetProjects())
    }

    prevUserId.current = designerId
  }, [prevUserId, designerId, dispatch, isProfile])

  const loadProjects = useCallback(() => {
    dispatch(fetchProjectsGrid({
      filter,
      channelOwnerId,
      currentCategory,
      contextName,
      isChannel: !!isChannel,
      currentTab,
      teamId,
      accountId,
      designerId,
      teachersOnly,
      isMe: (isMe || !!isFeedPage),
      isHseSpaceDesignerPage,
      moderationType,
      productCards,

      //todo [МУСОР] удалить
      isLMSHSE,
      isProfile,
      isPeoplePage,
      isCompetitions,
      isLectureMedia,
      isSchool,
      team,
      isResidentsPage,
    }))
  }, [
    dispatch,
    filter,
    campusType,
    moderationType,
    channelOwnerId,
    currentCategory,
    contextName,
    isChannel,
    currentTab,
    teamId,
    team,
    accountId,
    isProfile,
    isPeoplePage,
    isCompetitions,
    isLMSHSE,
    isMe,
    isFeedPage,
    isLectureMedia,
    isSchool,
    designerId,
    teachersOnly,
    isResidentsPage
  ])

  useEffect(() => {
    const tabsLoaded = !!Object.keys(preloadedTabs as {}).length;
    const isProfile = contextName?.startsWith('profile');
    const currentTabLoaded = tabDataRef.current?.loaded && tabDataRef.current?.context === contextName && !isProfile;
    console.log({productCards, prevProductCardState})
    const alreadyLoaded = !!((isChannel ? (prevTeam === teamId) : (prevTeam === preloadedTabsContext))
      && currentTabLoaded
      && !isProfile) && tabsLoaded
      && productCards === prevProductCardState;

    const isSameRatingsFilter =
      JSON.stringify(prevRatingsFilterRef.current) === JSON.stringify(ratingsFilter);
    const shouldReloadByRatingsFilter = isRatingsEntityType && !isSameRatingsFilter;
    prevRatingsFilterRef.current = ratingsFilter;

    if (shouldReloadByRatingsFilter) {
      loadProjects();
      setInitialLoaded(true);
      return;
    }

    if (!alreadyLoaded && tabsLoaded && preloadedTabsContext === contextName) {
      loadProjects()
      setInitialLoaded(true)
    }
  }, [
    time,
    teamId,
    prevTeam,
    preloadedTabsContext,
    contextName,
    accountId,
    currentCategory,
    currentTab,
    preloadedTabs,
    isChannel,
    campusType,
    ratingsFilter,
    isRatingsEntityType,
    productCards,
    prevProductCardState
  ])

  const competitionStatusKey = Array.isArray(filter?.competitionStatus)
    ? filter.competitionStatus.join(',')
    : filter?.competitionStatus
  const requiredTagIdsKey = Array.isArray(filter?.requiredTagIds)
    ? filter.requiredTagIds.join(',')
    : filter?.requiredTagIds
  const byTagIdsKey = Array.isArray(filter?.byTagIds)
    ? filter.byTagIds.join(',')
    : filter?.byTagIds

  useEffectSkipFirst(() => {
    dispatch(ProjectsGridActions.resetProjects());
    loadProjects()
  }, [
    currentCategory,
    filter?.projectFilter,
    filter?.hasProductCards,
    filter?.isRating,
    filter?.moduleFormat,
    filter?.countryCode,
    competitionStatusKey,
    requiredTagIdsKey,
    filter?.sort,
    filter?.accountId,
    byTagIdsKey,
    tagId,
    teachersOnly,
    time,
    campusType,
    productCards,
    prevProductCardState
  ])

  useEffect(() => {
    if (initialLoaded) {
      initialLoadedRef.current = true
    }
  }, [initialLoaded])

  useEffect(() => {
    dispatch(ProjectsGridActions.setCurrentTeam(isChannel ? teamId : contextName))
    return () => {
      if (initialLoadedRef.current) {
        dispatch(ProjectsGridActions.setPrevTeam(isChannel ? teamId : contextName))
      }
    }
  }, [teamId, contextName, isChannel, dispatch])


  const handleUpdate = useCallback(() => {
    if (currentTab === DesignerTab.bookmarks) {
      reloadAllTabs();
    }
  }, [currentTab, reloadAllTabs])

  const onSetWideCoverProject = (project: Project) => {
    dispatch(WideCoverSlice.actions?.setWideProject(project))
  }

  const shouldVisibleDraftsGrid = useMemo(
    () => (isDrafts || !!['draft_books', 'drafts']?.includes(currentTab)), [isDrafts, currentTab])

  const isChannels = useMemo(() => {
    return currentTab === 'edu-channels' || currentTab === 'channels' || entityType === 'educationSubscribes' || teamId === ALL_CHANNELS_TEAM_ID
  }, [currentTab, entityType, teamId])

  const isCompetitionsGrid = useMemo(() => {
    return (entityType === 'jury' || entityType === 'competitions_new' /*|| entityType === 'practices'*/)
  } , [entityType])

  const canCreateProjectsIntoDrafts = useMemo(() => {
    return !isAgeyTomesh && !isStart && !isGreenAward && !isDafes && !isHH && !isHseCreative && !isLMSHSE && !isExam
  }, [])

  const translatedProjects = useMemo(() => {
    return data?.data ? API.toLang<Project[]>(data?.data, language) : []
  }, [data?.data, language]);

  useEffect(() => {
    if (onProjectsLoaded && initialLoaded && !fetchingTabs && translatedProjects) {
      onProjectsLoaded(translatedProjects);
    }
  }, [translatedProjects, initialLoaded, fetchingTabs, onProjectsLoaded, contextName, currentTab]);

  const sortedOrganizations = useMemo(() => {
    return Array.isArray(translatedProjects) ? translatedProjects : [];
  }, [translatedProjects]);

  const resolveTeamUrl = useCallback((team?: ComputedTeam) => {
    if (!team) return null;
    const isChannel = [/*ModerationType.Channel, */ModerationType.ChannelGroupOrCourse]?.includes(team?.moderationType ?? 0)
    const isOuter = team?.moderationType === ModerationType.Outer
    const isActuallyChannel = isChannel || team.mainEntityType === 'channels';

    // if (isOuter) {
    //   return getNormalizedOuterTeamPath(team?.route ?? '', team?.teamId)
    // }

    if (isMainPageHseSpace) {
      return team.route?.replace('/teams/s-', '/') || null;
    }

    if (isActuallyChannel || !team.route) {
      const baseUrl = process.env.REACT_APP_URL_MEDIIIA_COM || '';
      return `${baseUrl}/teams/${team.teamId}`;
    }

    return team.route;
  }, [isMainPageHseSpace]);

  const organizationsTeams = useMemo(() => {
    return sortedOrganizations
    // @ts-ignore
      .map(computeTeam)
      .map((team) => ({
        ...team,
        route: resolveTeamUrl(team) || team.route,
      }));
  }, [sortedOrganizations, resolveTeamUrl]);

  const handleTeamClick = (team?: ComputedTeam, e?: any, target: '_self' | '_blank' = '_self') => {
    e?.preventDefault();
    e?.stopPropagation();
    if (!team) return;
    const url = resolveTeamUrl(team);

    if (url) window.open(url, target);
  };

  const shouldViewWideCover = useMemo(
    () => (isMedia && translatedProjects?.length
    ), [
    isMedia,
    translatedProjects,
    hasWideCover,

  ])

  const showEmptyTabMsg = useMemo(
    () =>
      !fetchingTabs &&
      initialLoaded &&
      !translatedProjects?.length,
    [
      initialLoaded,
      isProfile,
      translatedProjects,
      isCompetitions,
      fetchingTabs,
      isMedia,
      emptyMsgComponent,
      emptyMsgText
    ])

  const largeMobOffset = useMemo(() => (isProfile), [isProfile])

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if (isParticipate && isParticipate.length > 0) {
      return data ? isParticipate.includes(data) : false;
    }
  }, [isParticipate])

  const fetchMoreProjectsNext = useCallback(() => {
    if (disableFetchingMore) {
      return
    }
    dispatch(fetchProjectsGridMore({
      currentTab,
      currentCategory,
      filter,
      accountId,
      isMe: isMe || !!isFeedPage,
      moderationType,
      isPeoplePage,
      isProfile,
      teamId,
      isCompetitions,
      isLMSHSE,
      isSchool,
      contextName,
      teachersOnly,
      isHseSpaceDesignerPage,
      team,
      isResidentsPage,
    }));
  }, [
    i18n,
    dispatch,
    currentCategory,
    teachersOnly,
    showcase,
    disableFetchingMore,
    teamId,
    team,
    moderationType,
    accountId,
    fetchProjectsGridMore,
    currentTab,
    filter,
    isPageWithoutTabs,
    preloadedTabs,
    contextName,
    isResidentsPage
  ])

  useEffect(() => {
    if (!showEmptyTabMsg && !fetchingTabs) {
      yandexWebmaster.onPageLoaded();
    }
  }, [showEmptyTabMsg, fetchingTabs]);

  useEffect(() => {
    if (shouldViewWideCover) {
      const proProject = translatedProjects?.find(
        (p: any) => p?.contexts?.includes('propresentation')
      )

      //@ts-ignore
      onSetWideCoverProject(proProject || undefined)
    }
  }, [
    shouldViewWideCover,
    onSetWideCoverProject,
    translatedProjects,
    filter?.projectFilter,
    filter?.currentCategory,
    currentTab,
    currentCategory
  ])

  const ShowMoreButtonOrLoading = useMemo(() => {

    if (!fetchingMore) {
      return null;
    }

    return (
      <FlexBox direction='column' directionMobile='column' width="100%">
        {/* @ts-ignore */}
        <GridWrapperNew mobileColumns={2} itemType={isAcademy && isMap && 'mapItem'}>
          {new Array(8).fill('').map((_, index) => {
            return isAcademy && isMap ? <SkeletonCardMap key={index} /> : <SkeletonCard key={index} />
          })}
        </GridWrapperNew>
        <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
          <ProgressBar
            text={t('text.loading')}
            loading={true}
            color={theme.progressbar.color}
          />
        </FlexBox>
      </FlexBox>
    )
  }, [t, theme, fetchingMore])

  if (hideProjects) {
    return null;
  }

  if (fetchingTabs && (['jury', 'competitions_new', 'competitions', 'practices']?.includes(entityType) || isChannels)) {
    return <ProjectsGridNew isLoading />
  }

  if (entityType === 'broadcast' || currentTabConfig?.entityType === 'broadcast') {
    return <BroadCastView broadcastLink={broadcastLink} />
  }

  if (entityType === 'competitions' || entityType === 'practices') {
    return (
      <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
        <DesignerCompetitionsTab
          onNotParticipateCompetition={handlers?.onNotParticipateCompetition}
          //@ts-ignore
          competitions={translatedProjects as ParticipateCompetitions}
        />
      </FlexBox>
    )
  }

  return (
    <>
    {!showEmptyTabMsg && !fetchingTabs && <div id="grid-loaded" />}
    <ScrollWrapper direction="column" directionMobile="column" gy={isMedia ? 0 : 40} flex="1">
      <InfiniteScroll
        style={scrollStyles}
        dataLength={translatedProjects?.length}
        next={fetchMoreProjectsNext}
        hasMore={!isFinalPage}
        initialScrollY={0}
        scrollThreshold={0.9}
        loader={ShowMoreButtonOrLoading}
        scrollableTarget={scrollableTarget}
        onScroll={onScroll}
      >{isChannels ? (
        <ChannelsGrid
          isEditable={false}
          // isMe={(isMe || !!isFeedPage)}
          //@ts-ignore
          teams={translatedProjects.map(computeTeam)}
          contextName={contextName}
          entityType={entityType}
          onTeamClick={(team?: ComputedTeam, e?: any) => 
            handleTeamClick(team, e, '_blank')
          }
          hasLinks
        />
      ) : ['organizations', DesignerTab.subscriptionsTeams]?.includes(entityType as DesignerTab | 'organizations') ? (
        <TeamGrid
          key={`organizations-${filter?.sort || 3}`}
          isEditable={false}
          isLoading={fetchingTabs}
          isMe={(!!isMe || !!isFeedPage)}
          //@ts-ignore
          teams={organizationsTeams}
          contextName={contextName}
          entityType={entityType}
          onTeamClick={(team?: ComputedTeam, e?: any) => 
            handleTeamClick(team, e, '_blank')
          }
          hasLinks
          currentTeam={currentTeam}
          currentTab={currentTab}
          isOuterOrganizationShowcase={isOuterOrganizationShowcase}
          onUpdate={reloadAllTabs}
          {...handlers}
        />
      ) : ['people', 'people_in_detail', 'subscribers', 'subscriptions', 'statuses', 'authors_ratings']?.includes(entityType) ? (
        <PeoplePageGrid
          language={i18n.language}
          isMe={(isMe || !!isFeedPage)}
          entityType={entityType}
          //inDetail={entityType === 'people_in_detail'}
          data={translatedProjects as unknown as Designer<'Local'>[]}
          showOpa={showOpa}
          showTags
          twoMobileColumns={['subscribers', 'subscriptions', 'people', 'statuses', 'authors_ratings']?.includes(entityType)}
          isOpaCard={isOpaCard}
          isLoading={loading}
          isMobileMoreVisible={['subscribers', 'subscriptions']?.includes(entityType)}
          {...handlers}
          tooltip={
            [
              DesignerTab.subscriptions]
              ?.includes(entityType) && (!!isMe || !!isFeedPage)
          }
        />
      ) : isCompetitionsGrid ? (
        <CompetitionGrid
          // @ts-ignore
          competitions={translatedProjects}
          isProfile={isProfile}
          isMainPage={isMainPage}
          notClickableTags
        />
      ) : entityType === 'discount' ? (
        <DesignerDiscountTab data={translatedProjects} isLoading={fetchingTabs} />
      ) : entityType === 'competitionCerts' ? (
        <DesignerDiscountTab data={translatedProjects} isLoading={fetchingTabs} isCert={true} />
      ) : shouldVisibleDraftsGrid ? (
        <DraftsGrid
          canCreateProjects={canCreateProjectsIntoDrafts}
          entityType={entityType}
          projects={translatedProjects}
          activeTabKey={currentTab}
          isExport={isExport}
          selectedProjects={selectedProjects}
          onSelectProject={onSelect}
          {...handlers} />
      ) : contextName === 'creativecityacademymap' && isMapPage ? (
        // @ts-ignore
        <PopupInfoNodeGrid isLoading={fetchingTabs}>{
          translatedProjects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
            // @ts-ignore
            const project = mapProjectToMapObject(v)
            return (
              <PopUpInfoNode
                loading={fetchingTabs}
                titleImage={project.titleImage}
                title={project.title}
                designer={project.designer}
                project={project.project}
                key={`${project.projectId}_section`}
                likes={project.likes}
                designers={[project.project.author].concat(project.project.coAuthors)}
                competitionId={project.competitionId}
                projectId={project.projectId}
                designerId={project.designerId}
                fixedSizeCard={true}
              />
            )
          })}
        </PopupInfoNodeGrid>
      ) : (
        isCompetitions && currentTab !== 'winners' ? <></>
          :
          <ProjectsGridNew
            k={isMainPage ? 20 : undefined}
            isLoading={fetchingTabs}
            columns={columns}
            mobileColumns={mobileColumns}
            largeMobOffset={largeMobOffset}
            isSuperPuperGames={!!isSuperPuperGames}
            currentTeam={currentTeam}
            currentTab={currentTab}
            forceOneColumn={hasAnnotation}
            showAnnotations={hasAnnotation}
          >
            {translatedProjects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
              if (entityType === 'content_type_for_display') {
                const cardId = (v as any)?.cardId ?? (v as any)?.entityId;
                return (
                  <ShopCard
                    useTemplateCard
                    entityType={entityType}
                    card={v as any}
                    key={cardId ?? index}
                    id={cardId}
                    additionalLinkPath={currentTabContentDisplayLinkParams}
                    images={(v as any)?.images}
                    name={(v as any)?.name}
                    price={(v as any)?.price}
                    isSold={(v as any)?.isSold}
                  />
                );
              }
              if (entityType === 'products') {
                const cardId = (v as any)?.cardId ?? (v as any)?.entityId;
                return (
                  <ShopCard
                    isProductsTabCard
                    useTemplateCard
                    entityType={entityType}
                    card={v as any}
                    key={cardId ?? index}
                    id={cardId}
                    additionalLinkPath={currentTabContentDisplayLinkParams}
                    images={(v as any)?.images}
                    name={(v as any)?.name}
                    price={(v as any)?.price}
                    isSold={(v as any)?.isSold}
                    customClick={() => {
                      const card = v as any
                      const cardId = card.entityId || card.cardId
                      const baseUrl = `${process.env.REACT_APP_URL_ARTZ_SHOP}/shop`
                      let fullUrl
                      if (card?.shopDomain) {
                        fullUrl = `https://${card.shopDomain}/card/${cardId}`
                      } else {
                        fullUrl = `${baseUrl}/card/${cardId}`
                      }
                      window.open(fullUrl, '_blank')
                    }}
                  />
                );
              }
              if (filter?.isPaid || !!preloadedTabs?.main?.find((x: any) => x.path == currentTab)?.filter?.isPaid) {
                //@ts-ignore
                const price = v?.additionalInfo?.['productPrice'] ?? ''
                return (
                  // @ts-ignore
                  <ShopCard
                    project={v}
                    customClick={() => window.open(CreateLinkTo.book(v?.projectId ?? ''), '_self')}
                    key={v?.projectId}
                    id={v?.projectId}
                    images={v?.titleImages}
                    name={Lang(v?.title, i18n.language)}
                    price={price}
                    isBook
                  />
                )
              }
              return (
                <ProjectCardItem
                  isOneColumn={hasAnnotation}
                  key={(v?.projectId || '') + index}
                  project={v}
                  selectable={selectable}
                  selected={selectedProjects?.includes(v?.projectId ?? '')}
                  onSelect={onSelect}
                  modal={modal}
                  withoutGoToProject={withoutGoToProject}
                  withoutRepost={withoutRepost}
                  linkPrefix={linkPrefix}
                  entityType={entityType}
                  alreadyProject={isAlreadyProject(v?.projectId)}
                  showCompetitionPoint={showCompetitionPoint}
                  canMakeImageForTeam={canMakeImageForTeam}
                  onShouldReload={reloadAllTabs}
                  onUpdate={handleUpdate}
                  placement={placement}
                  isChannel={isChannel}
                  isParticipant={isChannelParticipant}
                  checkBookPaid={true}
                  showAnnotations={hasAnnotation}
                  isExport={isExport}
                  isOuterOrganizationShowcase={isOuterOrganizationShowcase}
                />
              );
            })}
          </ProjectsGridNew>
      )}
      </InfiniteScroll>
      <EmptyCardsLoading k={isMainPage ? 0 : 8} isLoading={fetchingTabs} />
      {showEmptyTabMsg && (emptyMsgComponent || <EmptyCategory text={emptyMsgText} />)}
      <OffsetBlock display={(!paging?.pages || paging?.pages === 1)} />
    </ScrollWrapper>
    </>
  );
};

export default memo(ProjectsButchControllerUltimate)
import { FC, useEffect, useState, useMemo, memo, useCallback, useRef, ReactNode, lazy } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Nullable, Project, API, ParticipateCompetitions, Lang, Designer } from '@brg/api';
import { useProfile } from '@brg/auth';
import { FlexBox } from '@brg/ui';
import InfiniteScroll from 'react-infinite-scroll-component';

import { ChannelsGrid, GridWrapperNew, ProjectsGridNew, TeamGrid } from '../../shared/components/grids';
import { ProjectCardItem } from './ProjectsButchController/ProjectCardItem';
import useQueryStateOrigin from "../../shared/hooks/useQueryState";
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'shared/icons/Progress';
import styled, { useTheme } from 'styled-components';
import { AppTester } from "supporting";
import { EmptyCardsLoading } from 'shared/components/CardsLoading/EmptyCards';
import { SkeletonCard, SkeletonCardMap } from 'shared/components/SkeletonCard/SkeletonCard';
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { ProjectsGridActions, ProjectsGridSelector } from "../../shared/reducers/ProjectsGridSlice";
import { fetchProjectsGrid, fetchProjectsGridMore } from "../../shared/actions/projectsGridActions";
import { ComputedTeam, computeTeam } from "../../shared/helpers/types/computed/ComputedTeam";
import { DesignerCompetitionsTab } from "../../shared/pages/designer/components/tabs/designerCompetitionsTab";
import { CombinedEvents } from "../../shared/helpers/projectEvents";
import { DraftsGrid } from "../../shared/pages/designer/components/draftsGrid";
import { DesignerTab } from "../../shared/constants/designerTab";
import { ModerationType } from "../../shared/pages/teams/const/ModerationTypes";
import CompetitionGrid from "../../_competition/pages/AllCompetitionsPage/CompetitionGrid";
import WideCoverSlice, { WideCoverSelector } from 'shared/reducers/WideCoverSlice';
import { EmptyCategory } from 'shared/components/EmptyCategory/EmptyCategory';
import { ShopCard } from 'shared/pages/Shop/ShopCard';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import { DesignerDiscountTab } from 'shared/pages/designer/components/tabs/designerDiscountstab';
import { useParams, useRouteMatch as useRouteMatchOrigin } from "react-router-dom";
import { PeoplePageGrid } from 'shared/pages/context/support/Grid';
import { mapProjectToMapObject } from 'shared/pages/ResearchPage/Research/Frames/FramesSsr/mapProjectToMapObject';
import { isServer } from 'shared/constants/isServer';
import { useParamsSsr, useRouteMatchSsr } from 'shared/hooks/useRouteMatchSsr';
import { ProfileFoldersProps, ProfileFoldersSelector } from 'shared/reducers/ProfileFoldersSlice';
import { Placement } from 'shared/components/tooltips';
import useEffectSkipFirst from 'core/hooks/useEffectSkipFirst';
import { ALL_CHANNELS_TEAM_ID } from 'shared/pages/exploreHseContextsNew/const/misc';
import { getNormalizedOuterTeamPath } from 'core/helpers/getNormalizedOuterTeamPath';
import { isManualTab } from './helpers/isManualTab';
import { EMPTY_CONTENT_TAB } from 'shared/pages/designer/components/NoProjectsContent';
import { BroadCastView } from 'shared/components/BroadCastView/BroadCastView';
import { IShowcaseRatingsFilter } from 'shared/constants/ShowcaseRatings';
import yandexWebmaster from 'shared/webmaster/yandexWebmaster';

const useRouteMatch = isServer ? useRouteMatchSsr : useRouteMatchOrigin
const useQueryState = isServer ? () => [{ teachersOnly: false, showcase: false, folderId: false, tagId: false, campusType: false, productCards }] : useQueryStateOrigin
const PopupInfoNodeGrid = isServer ? FlexBox : lazy(() => import('shared/pages/ResearchPage/Research/Components/Popup/stylesSsr/PopupInfoNodeGrid'))
const PopUpInfoNode = isServer ? FlexBox : lazy(() => import('../../shared/pages/ResearchPage/Research/Components/Popup/PopUpInfoNode'))
const usedUseParams = isServer ? useParamsSsr : useParams
const useParamsProps = isServer ? LinkTo.designer : undefined

export const StyledLoading = styled.div`
  margin-bottom: 40px;
  padding: 10px;
  font-size: 60px;
  line-height: 1;
  color: white;
  text-align: center;
`;

export const ShowMoreWrapper = styled(FlexBox)`
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${p => p.theme.progressbar.borderColor};
  border-radius: 3px;
  padding: 12px 48px;
`;

const OffsetBlock = styled.div<{ display: boolean }>`
  width: 100%;
  margin-top: 64px;
  display: ${p => p?.display ? 'inline-block' : 'none'};
`;

const ScrollWrapper = styled(FlexBox)`
  .infinite-scroll-component {
    overflow: visible !important;
  }
`

type Tabs = {
  [key: string]: string[] | string | null;
}

export interface ProjectsButchControllerProps<T = Project> {
  filter: any;
  onProjectsLoaded?: (projects: T[]) => void;
  selectable?: boolean;
  onSelect?: (projectId: string) => void;
  withoutGoToProject?: boolean;
  withoutRepost?: boolean;
  selectedProjects?: string[];
  isParticipate?: string[];
  modal?: boolean;
  linkPrefix?: string;
  projectsCount?: number;
  isLoading?: Function;
  isSelectRightNeed?: boolean;
  columns?: number;
  isUnload?: boolean;
  preloadedTabs?: Tabs[];
  emptyMsgComponent?: ReactNode;
  currentTab: string;
  currentCategory: string;
  contextName?: string;
  isPageWithoutTabs?: boolean;
  emptyMsgText?: string;
  showCompetitionPoint?: boolean;
  isChannelParticipant?: boolean;
  isTeamProjects?: boolean;
  isDisabled?: boolean;
  canMakeImageForTeam?: TOwnerRights;
  isMainPage?: boolean;
  isProfile?: boolean;
  isPeoplePage?: boolean;
  isCompetitions?: boolean;
  handlers?: CombinedEvents;
  moderationType?: ModerationType;
  loading?: boolean;
  teamId?: string;
  team?: any;
  accountId?: string;
  mobileColumns?: number;
  scrollableTarget?: any;
  isMe?: number;
  scrollStyles?: any;
  showOpa?: boolean;
  channelOwnerId?: string;
  isOpaCard?: boolean;
  isMobileMoreVisible?: boolean;
  placement?: Placement;
  onScroll?: (e: any) => void;
  isExport?: boolean;
}

const ProjectsButchControllerUltimate: FC<ProjectsButchControllerProps> = ({
  filter,
  selectable = false,
  modal = false,
  onSelect = () => undefined,
  withoutGoToProject,
  selectedProjects = [],
  isParticipate = [],
  linkPrefix,
  columns,
  isPageWithoutTabs,
  withoutRepost,
  contextName,
  teamId,
  team,
  accountId,
  currentTab,
  scrollStyles,
  currentCategory,
  showCompetitionPoint,
  canMakeImageForTeam,
  isProfile,
  isPeoplePage,
  isCompetitions,
  isMainPage,
  handlers,
  mobileColumns,
  loading,
  emptyMsgComponent,
  isChannelParticipant,
  emptyMsgText,
  moderationType,
  scrollableTarget,
  isMe,
  showOpa,
  isOpaCard,
  channelOwnerId,
  placement,
  onScroll,
  onProjectsLoaded,
  isExport,
}) => {
  const designer = useProfile();
  const theme = useTheme();
  const isMapPage = useRouteMatch('/map');
  const isFeedPage = useRouteMatch('/feed');
  const isResidentsPage = !!useRouteMatch('/residents');

  const [{ teachersOnly, showcase = false, folderId, tagId, campusType, productCards }] = useQueryState();
  const { id: designerId } = usedUseParams(useParamsProps)

  const dispatch = useDispatch();
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isMedia = AppTester.isMediiia();
  const isMediiiaConcept = AppTester.isMediiiaConcept()
  const isLMSHSE = AppTester.isLMSHSE();
  const isGreenAward = AppTester.isGreenAward();
  const isDafes = AppTester.isGeoDafes();
  const isHH = AppTester.isContext('hsehh');
  const isHseCreative = AppTester.isLMSHSECreative();
  const isLectureMedia = AppTester.isLectureMediiia();
  const isSchool = AppTester.isSchool()
  const isStart = AppTester.isStartHSE();
  const isExam = AppTester.isExamHSE()
  const isAcademy = AppTester.isAcademy();
  const isMap = !!useRouteMatch('/map');
  const isExactPage = !!useRouteMatch('/');
  const isMainPageHseSpace = AppTester.isContext('hsespace') && isExactPage;
  const isHseSpaceDesignerPage = AppTester.isContext('hsespace') && !!useRouteMatch(LinkTo.designer)
  const { t, i18n, i18n: { language } } = useTranslation();
  const [time, setTime] = useState(Date.now());
  const [initialLoaded, setInitialLoaded] = useState(false)
  const initialLoadedRef = useRef(false)
  const tabDataRef = useRef<any>(null)

  const prevUserId = useRef<any>(null);

  const hasWideCover = useSelector(WideCoverSelector)?.project;
  const preloadedTabs = useSelector(ProjectsGridSelector)?.tabs;
  const preloadedTabsContext = useSelector(ProjectsGridSelector)?.context;
  const data = useSelector(ProjectsGridSelector)?.data?.[currentCategory]?.[currentTab];
  const fetchingTabs = useSelector(ProjectsGridSelector)?.tabsLoading?.[currentCategory]?.[currentTab];
  const fetchingMore = useSelector(ProjectsGridSelector)?.fetchingMore;
  const prevTeam = useSelector(ProjectsGridSelector)?.prevTeam;
  const ratingsFilter = useSelector(ProjectsGridSelector)?.ratingsFilter;
  const prevRatingsFilterRef = useRef<IShowcaseRatingsFilter | undefined>(ratingsFilter);
  const currentFolder = useSelector(ProfileFoldersSelector)?.currentFolder;
  const prevProductCardState = useSelector(ProjectsGridSelector)?.prevProductCardFilter;
  //@ts-ignore
  const currentTeam = useSelector((state) => state?.organizations)?.team;

  tabDataRef.current = data;

  const isChannel = useMemo(() => {
    return moderationType && [/*ModerationType.Channel,*/ ModerationType.ChannelGroupOrCourse]?.includes(moderationType)
  } , [moderationType])

  const isOuterOrganizationShowcase = useMemo(
    () => moderationType === ModerationType.Outer || team?.moderationType === ModerationType.Outer,
    [moderationType, team],
  )

  const isSuperPuperGames = useMemo(
    () => ((currentTeam?.contextName === 'superpupergames-mediiia'))
    , [currentTeam]);

  const currentTabContentDisplayLinkParams = useMemo(
    () => preloadedTabs?.main?.find((x: any) => x.path === currentTab)?.entityTypeAdditionalLinkParams,
    [preloadedTabs, currentTab]
  );

  const currentTabConfig = useMemo(
    () => preloadedTabs?.[currentCategory]?.find((x: any) => x.path === currentTab)
      ?? preloadedTabs?.main?.find((x: any) => x.path === currentTab),
    [preloadedTabs, currentCategory, currentTab],
  );

  const broadcastLink = useMemo(
    () => currentTabConfig?.filter?.broadcastLink
      ?? currentTabConfig?.broadcastLink
      ?? filter?.broadcastLink
      ?? '',
    [currentTabConfig, filter?.broadcastLink],
  );

  const hideProjects = useMemo(() => {
    if (currentTab === EMPTY_CONTENT_TAB) {
      return false
    }
    return ([ProfileFoldersProps.create, ProfileFoldersProps.edit]?.includes(currentFolder) || folderId) && isProfile
  }, [folderId, isProfile, currentFolder, currentTab])

  const disableFetchingMore = useMemo(() => {
    if (currentTab === 'competitionCerts') return true;
    return isManualTab(data?.usingFilterOrManual)
  }, [data?.usingFilterOrManual])

  const reloadAllTabs = useCallback(() => {
    setTime(Date.now());
    handlers?.onUpdate?.();
  }, [handlers])

  const { isFinalPage, paging, entityType, isDrafts, hasAnnotation } = data || {};
  const ratingsTabEntityType = currentTabConfig?.entityType || entityType;
  const isRatingsEntityType = ['projects_ratings', 'authors_ratings'].includes(ratingsTabEntityType);

  const hasCachedData = useMemo(() => {
    return !!(data?.data && data.data.length > 0);
  }, [data]);

  useEffect(() => {
    if (isProfile && prevUserId.current && prevUserId.current !== designerId) {
      dispatch(ProjectsGridActions.resetProjects())
    }

    prevUserId.current = designerId
  }, [prevUserId, designerId, dispatch, isProfile])

  const loadProjects = useCallback(() => {
    dispatch(fetchProjectsGrid({
      filter,
      channelOwnerId,
      currentCategory,
      contextName,
      isChannel: !!isChannel,
      currentTab,
      teamId,
      accountId,
      designerId,
      teachersOnly,
      isMe: (isMe || !!isFeedPage),
      isHseSpaceDesignerPage,
      moderationType,
      productCards,

      //todo [МУСОР] удалить
      isLMSHSE,
      isProfile,
      isPeoplePage,
      isCompetitions,
      isLectureMedia,
      isSchool,
      team,
      isResidentsPage,
    }))
  }, [
    dispatch,
    filter,
    campusType,
    moderationType,
    channelOwnerId,
    currentCategory,
    contextName,
    isChannel,
    currentTab,
    teamId,
    team,
    accountId,
    isProfile,
    isPeoplePage,
    isCompetitions,
    isLMSHSE,
    isMe,
    isFeedPage,
    isLectureMedia,
    isSchool,
    designerId,
    teachersOnly,
    isResidentsPage
  ])

  useEffect(() => {
    const tabsLoaded = !!Object.keys(preloadedTabs as {}).length;
    const isProfile = contextName?.startsWith('profile');
    const currentTabLoaded = tabDataRef.current?.loaded && tabDataRef.current?.context === contextName && !isProfile;
    console.log({productCards, prevProductCardState})
    const alreadyLoaded = !!((isChannel ? (prevTeam === teamId) : (prevTeam === preloadedTabsContext))
      && currentTabLoaded
      && !isProfile) && tabsLoaded
      && productCards === prevProductCardState;

    const isSameRatingsFilter =
      JSON.stringify(prevRatingsFilterRef.current) === JSON.stringify(ratingsFilter);
    const shouldReloadByRatingsFilter = isRatingsEntityType && !isSameRatingsFilter;
    prevRatingsFilterRef.current = ratingsFilter;

    if (shouldReloadByRatingsFilter) {
      loadProjects();
      setInitialLoaded(true);
      return;
    }

    if (!alreadyLoaded && tabsLoaded && preloadedTabsContext === contextName) {
      loadProjects()
      setInitialLoaded(true)
    }
  }, [
    time,
    teamId,
    prevTeam,
    preloadedTabsContext,
    contextName,
    accountId,
    currentCategory,
    currentTab,
    preloadedTabs,
    isChannel,
    campusType,
    ratingsFilter,
    isRatingsEntityType,
    productCards,
    prevProductCardState
  ])

  const competitionStatusKey = Array.isArray(filter?.competitionStatus)
    ? filter.competitionStatus.join(',')
    : filter?.competitionStatus
  const requiredTagIdsKey = Array.isArray(filter?.requiredTagIds)
    ? filter.requiredTagIds.join(',')
    : filter?.requiredTagIds
  const byTagIdsKey = Array.isArray(filter?.byTagIds)
    ? filter.byTagIds.join(',')
    : filter?.byTagIds

  useEffectSkipFirst(() => {
    dispatch(ProjectsGridActions.resetProjects());
    loadProjects()
  }, [
    currentCategory,
    filter?.projectFilter,
    filter?.hasProductCards,
    filter?.isRating,
    filter?.moduleFormat,
    filter?.countryCode,
    competitionStatusKey,
    requiredTagIdsKey,
    filter?.sort,
    filter?.accountId,
    byTagIdsKey,
    tagId,
    teachersOnly,
    time,
    campusType,
    productCards,
    prevProductCardState
  ])

  useEffect(() => {
    if (initialLoaded) {
      initialLoadedRef.current = true
    }
  }, [initialLoaded])

  useEffect(() => {
    dispatch(ProjectsGridActions.setCurrentTeam(isChannel ? teamId : contextName))
    return () => {
      if (initialLoadedRef.current) {
        dispatch(ProjectsGridActions.setPrevTeam(isChannel ? teamId : contextName))
      }
    }
  }, [teamId, contextName, isChannel, dispatch])


  const handleUpdate = useCallback(() => {
    if (currentTab === DesignerTab.bookmarks) {
      reloadAllTabs();
    }
  }, [currentTab, reloadAllTabs])

  const onSetWideCoverProject = (project: Project) => {
    dispatch(WideCoverSlice.actions?.setWideProject(project))
  }

  const shouldVisibleDraftsGrid = useMemo(
    () => (isDrafts || !!['draft_books', 'drafts']?.includes(currentTab)), [isDrafts, currentTab])

  const isChannels = useMemo(() => {
    return currentTab === 'edu-channels' || currentTab === 'channels' || entityType === 'educationSubscribes' || teamId === ALL_CHANNELS_TEAM_ID
  }, [currentTab, entityType, teamId])

  const isCompetitionsGrid = useMemo(() => {
    return (entityType === 'jury' || entityType === 'competitions_new' /*|| entityType === 'practices'*/)
  } , [entityType])

  const canCreateProjectsIntoDrafts = useMemo(() => {
    return !isAgeyTomesh && !isStart && !isGreenAward && !isDafes && !isHH && !isHseCreative && !isLMSHSE && !isExam
  }, [])

  const translatedProjects = useMemo(() => {
    return data?.data ? API.toLang<Project[]>(data?.data, language) : []
  }, [data?.data, language]);

  useEffect(() => {
    if (onProjectsLoaded && initialLoaded && !fetchingTabs && translatedProjects) {
      onProjectsLoaded(translatedProjects);
    }
  }, [translatedProjects, initialLoaded, fetchingTabs, onProjectsLoaded, contextName, currentTab]);

  const sortedOrganizations = useMemo(() => {
    return Array.isArray(translatedProjects) ? translatedProjects : [];
  }, [translatedProjects]);

  const resolveTeamUrl = useCallback((team?: ComputedTeam) => {
    if (!team) return null;
    const isChannel = [/*ModerationType.Channel, */ModerationType.ChannelGroupOrCourse]?.includes(team?.moderationType ?? 0)
    const isOuter = team?.moderationType === ModerationType.Outer
    const isActuallyChannel = isChannel || team.mainEntityType === 'channels';

    // if (isOuter) {
    //   return getNormalizedOuterTeamPath(team?.route ?? '', team?.teamId)
    // }

    if (isMainPageHseSpace) {
      return team.route?.replace('/teams/s-', '/') || null;
    }

    if (isActuallyChannel || !team.route) {
      const baseUrl = process.env.REACT_APP_URL_MEDIIIA_COM || '';
      return `${baseUrl}/teams/${team.teamId}`;
    }

    return team.route;
  }, [isMainPageHseSpace]);

  const organizationsTeams = useMemo(() => {
    return sortedOrganizations
    // @ts-ignore
      .map(computeTeam)
      .map((team) => ({
        ...team,
        route: resolveTeamUrl(team) || team.route,
      }));
  }, [sortedOrganizations, resolveTeamUrl]);

  const handleTeamClick = (team?: ComputedTeam, e?: any, target: '_self' | '_blank' = '_self') => {
    e?.preventDefault();
    e?.stopPropagation();
    if (!team) return;
    const url = resolveTeamUrl(team);

    if (url) window.open(url, target);
  };

  const shouldViewWideCover = useMemo(
    () => (isMedia && translatedProjects?.length
    ), [
    isMedia,
    translatedProjects,
    hasWideCover,

  ])

  const showEmptyTabMsg = useMemo(
    () =>
      !fetchingTabs &&
      initialLoaded &&
      !translatedProjects?.length,
    [
      initialLoaded,
      isProfile,
      translatedProjects,
      isCompetitions,
      fetchingTabs,
      isMedia,
      emptyMsgComponent,
      emptyMsgText
    ])

  const largeMobOffset = useMemo(() => (isProfile), [isProfile])

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if (isParticipate && isParticipate.length > 0) {
      return data ? isParticipate.includes(data) : false;
    }
  }, [isParticipate])

  const fetchMoreProjectsNext = useCallback(() => {
    if (disableFetchingMore) {
      return
    }
    dispatch(fetchProjectsGridMore({
      currentTab,
      currentCategory,
      filter,
      accountId,
      isMe: isMe || !!isFeedPage,
      moderationType,
      isPeoplePage,
      isProfile,
      teamId,
      isCompetitions,
      isLMSHSE,
      isSchool,
      contextName,
      teachersOnly,
      isHseSpaceDesignerPage,
      team,
      isResidentsPage,
    }));
  }, [
    i18n,
    dispatch,
    currentCategory,
    teachersOnly,
    showcase,
    disableFetchingMore,
    teamId,
    team,
    moderationType,
    accountId,
    fetchProjectsGridMore,
    currentTab,
    filter,
    isPageWithoutTabs,
    preloadedTabs,
    contextName,
    isResidentsPage
  ])

  useEffect(() => {
    if (!showEmptyTabMsg && !fetchingTabs) {
      yandexWebmaster.onPageLoaded();
    }
  }, [showEmptyTabMsg, fetchingTabs]);

  useEffect(() => {
    if (shouldViewWideCover) {
      const proProject = translatedProjects?.find(
        (p: any) => p?.contexts?.includes('propresentation')
      )

      //@ts-ignore
      onSetWideCoverProject(proProject || undefined)
    }
  }, [
    shouldViewWideCover,
    onSetWideCoverProject,
    translatedProjects,
    filter?.projectFilter,
    filter?.currentCategory,
    currentTab,
    currentCategory
  ])

  const ShowMoreButtonOrLoading = useMemo(() => {

    if (!fetchingMore) {
      return null;
    }

    return (
      <FlexBox direction='column' directionMobile='column' width="100%">
        {/* @ts-ignore */}
        <GridWrapperNew mobileColumns={2} itemType={isAcademy && isMap && 'mapItem'}>
          {new Array(8).fill('').map((_, index) => {
            return isAcademy && isMap ? <SkeletonCardMap key={index} /> : <SkeletonCard key={index} />
          })}
        </GridWrapperNew>
        <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
          <ProgressBar
            text={t('text.loading')}
            loading={true}
            color={theme.progressbar.color}
          />
        </FlexBox>
      </FlexBox>
    )
  }, [t, theme, fetchingMore])

  if (hideProjects) {
    return null;
  }

  if (fetchingTabs && (['jury', 'competitions_new', 'competitions', 'practices']?.includes(entityType) || isChannels)) {
    return <ProjectsGridNew isLoading />
  }

  if (entityType === 'broadcast' || currentTabConfig?.entityType === 'broadcast') {
    return <BroadCastView broadcastLink={broadcastLink} />
  }

  if (entityType === 'competitions' || entityType === 'practices') {
    return (
      <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
        <DesignerCompetitionsTab
          onNotParticipateCompetition={handlers?.onNotParticipateCompetition}
          //@ts-ignore
          competitions={translatedProjects as ParticipateCompetitions}
        />
      </FlexBox>
    )
  }

  return (
    <>
    {!showEmptyTabMsg && !fetchingTabs && <div id="grid-loaded" />}
    <ScrollWrapper direction="column" directionMobile="column" gy={isMedia ? 0 : 40} flex="1">
      <InfiniteScroll
        style={scrollStyles}
        dataLength={translatedProjects?.length}
        next={fetchMoreProjectsNext}
        hasMore={!isFinalPage}
        initialScrollY={0}
        scrollThreshold={0.9}
        loader={ShowMoreButtonOrLoading}
        scrollableTarget={scrollableTarget}
        onScroll={onScroll}
      >{isChannels ? (
        <ChannelsGrid
          isEditable={false}
          // isMe={(isMe || !!isFeedPage)}
          //@ts-ignore
          teams={translatedProjects.map(computeTeam)}
          contextName={contextName}
          entityType={entityType}
          onTeamClick={(team?: ComputedTeam, e?: any) => 
            handleTeamClick(team, e, '_blank')
          }
          hasLinks
        />
      ) : ['organizations', DesignerTab.subscriptionsTeams]?.includes(entityType as DesignerTab | 'organizations') ? (
        <TeamGrid
          key={`organizations-${filter?.sort || 3}`}
          isEditable={false}
          isLoading={fetchingTabs}
          isMe={(!!isMe || !!isFeedPage)}
          //@ts-ignore
          teams={organizationsTeams}
          contextName={contextName}
          entityType={entityType}
          onTeamClick={(team?: ComputedTeam, e?: any) => 
            handleTeamClick(team, e, '_blank')
          }
          hasLinks
          currentTeam={currentTeam}
          currentTab={currentTab}
          isOuterOrganizationShowcase={isOuterOrganizationShowcase}
          onUpdate={reloadAllTabs}
          {...handlers}
        />
      ) : ['people', 'people_in_detail', 'subscribers', 'subscriptions', 'statuses', 'authors_ratings']?.includes(entityType) ? (
        <PeoplePageGrid
          language={i18n.language}
          isMe={(isMe || !!isFeedPage)}
          entityType={entityType}
          //inDetail={entityType === 'people_in_detail'}
          data={translatedProjects as unknown as Designer<'Local'>[]}
          showOpa={showOpa}
          showTags
          twoMobileColumns={['subscribers', 'subscriptions', 'people', 'statuses', 'authors_ratings']?.includes(entityType)}
          isOpaCard={isOpaCard}
          isLoading={loading}
          isMobileMoreVisible={['subscribers', 'subscriptions']?.includes(entityType)}
          {...handlers}
          tooltip={
            [
              DesignerTab.subscriptions]
              ?.includes(entityType) && (!!isMe || !!isFeedPage)
          }
        />
      ) : isCompetitionsGrid ? (
        <CompetitionGrid
          // @ts-ignore
          competitions={translatedProjects}
          isProfile={isProfile}
          isMainPage={isMainPage}
          notClickableTags
        />
      ) : entityType === 'discount' ? (
        <DesignerDiscountTab data={translatedProjects} isLoading={fetchingTabs} />
      ) : entityType === 'competitionCerts' ? (
        <DesignerDiscountTab data={translatedProjects} isLoading={fetchingTabs} isCert={true} />
      ) : shouldVisibleDraftsGrid ? (
        <DraftsGrid
          canCreateProjects={canCreateProjectsIntoDrafts}
          entityType={entityType}
          projects={translatedProjects}
          activeTabKey={currentTab}
          isExport={isExport}
          selectedProjects={selectedProjects}
          onSelectProject={onSelect}
          {...handlers} />
      ) : contextName === 'creativecityacademymap' && isMapPage ? (
        // @ts-ignore
        <PopupInfoNodeGrid isLoading={fetchingTabs}>{
          translatedProjects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
            // @ts-ignore
            const project = mapProjectToMapObject(v)
            return (
              <PopUpInfoNode
                loading={fetchingTabs}
                titleImage={project.titleImage}
                title={project.title}
                designer={project.designer}
                project={project.project}
                key={`${project.projectId}_section`}
                likes={project.likes}
                designers={[project.project.author].concat(project.project.coAuthors)}
                competitionId={project.competitionId}
                projectId={project.projectId}
                designerId={project.designerId}
                fixedSizeCard={true}
              />
            )
          })}
        </PopupInfoNodeGrid>
      ) : (
        isCompetitions && currentTab !== 'winners' ? <></>
          :
          <ProjectsGridNew
            k={isMainPage ? 20 : undefined}
            isLoading={fetchingTabs}
            columns={columns}
            mobileColumns={mobileColumns}
            largeMobOffset={largeMobOffset}
            isSuperPuperGames={!!isSuperPuperGames}
            currentTeam={currentTeam}
            currentTab={currentTab}
            forceOneColumn={hasAnnotation}
            showAnnotations={hasAnnotation}
          >
            {translatedProjects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
              if (entityType === 'content_type_for_display') {
                const cardId = (v as any)?.cardId ?? (v as any)?.entityId;
                return (
                  <ShopCard
                    useTemplateCard
                    entityType={entityType}
                    card={v as any}
                    key={cardId ?? index}
                    id={cardId}
                    additionalLinkPath={currentTabContentDisplayLinkParams}
                    images={(v as any)?.images}
                    name={(v as any)?.name}
                    price={(v as any)?.price}
                    isSold={(v as any)?.isSold}
                  />
                );
              }
              if (entityType === 'products') {
                const cardId = (v as any)?.cardId ?? (v as any)?.entityId;
                return (
                  <ShopCard
                    isProductsTabCard
                    useTemplateCard
                    entityType={entityType}
                    card={v as any}
                    key={cardId ?? index}
                    id={cardId}
                    additionalLinkPath={currentTabContentDisplayLinkParams}
                    images={(v as any)?.images}
                    name={(v as any)?.name}
                    price={(v as any)?.price}
                    isSold={(v as any)?.isSold}
                    customClick={() => {
                      const card = v as any
                      const cardId = card.entityId || card.cardId
                      const baseUrl = `${process.env.REACT_APP_URL_ARTZ_SHOP}/shop`
                      let fullUrl
                      if (card?.shopDomain) {
                        fullUrl = `https://${card.shopDomain}/card/${cardId}`
                      } else {
                        fullUrl = `${baseUrl}/card/${cardId}`
                      }
                      window.open(fullUrl, '_blank')
                    }}
                  />
                );
              }
              if (filter?.isPaid || !!preloadedTabs?.main?.find((x: any) => x.path == currentTab)?.filter?.isPaid) {
                //@ts-ignore
                const price = v?.additionalInfo?.['productPrice'] ?? ''
                return (
                  // @ts-ignore
                  <ShopCard
                    project={v}
                    customClick={() => window.open(CreateLinkTo.book(v?.projectId ?? ''), '_self')}
                    key={v?.projectId}
                    id={v?.projectId}
                    images={v?.titleImages}
                    name={Lang(v?.title, i18n.language)}
                    price={price}
                    isBook
                  />
                )
              }
              return (
                <ProjectCardItem
                  isOneColumn={hasAnnotation}
                  key={(v?.projectId || '') + index}
                  project={v}
                  selectable={selectable}
                  selected={selectedProjects?.includes(v?.projectId ?? '')}
                  onSelect={onSelect}
                  modal={modal}
                  withoutGoToProject={withoutGoToProject}
                  withoutRepost={withoutRepost}
                  linkPrefix={linkPrefix}
                  entityType={entityType}
                  alreadyProject={isAlreadyProject(v?.projectId)}
                  showCompetitionPoint={showCompetitionPoint}
                  canMakeImageForTeam={canMakeImageForTeam}
                  onShouldReload={reloadAllTabs}
                  onUpdate={handleUpdate}
                  placement={placement}
                  isChannel={isChannel}
                  isParticipant={isChannelParticipant}
                  checkBookPaid={true}
                  showAnnotations={hasAnnotation}
                  isExport={isExport}
                  isOuterOrganizationShowcase={isOuterOrganizationShowcase}
                />
              );
            })}
          </ProjectsGridNew>
      )}
      </InfiniteScroll>
      <EmptyCardsLoading k={isMainPage ? 0 : 8} isLoading={fetchingTabs} />
      {showEmptyTabMsg && (emptyMsgComponent || <EmptyCategory text={emptyMsgText} />)}
      <OffsetBlock display={(!paging?.pages || paging?.pages === 1)} />
    </ScrollWrapper>
    </>
  );
};

export default memo(ProjectsButchControllerUltimate)
